import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['popout', 'trigger']

  toggle() {
    this.#setActive(this.element.dataset.active !== 'true')
  }

  close(event) {
    if (this.element.contains(event.target)) return

    this.#setActive(false)
  }

  #setActive(active) {
    const value = active.toString()

    this.element.dataset.active = value
    this.popoutTarget.inert = !active
    this.popoutTarget.setAttribute('aria-hidden', (!active).toString())
    this.triggerTarget.setAttribute('aria-expanded', value)
  }
}
